export var formatDateTimeIntl = function (locale) {
    return function (intlOptions) {
        if (intlOptions === void 0) { intlOptions = {}; }
        return Intl.DateTimeFormat(locale, intlOptions);
    };
};
//# sourceMappingURL=formatDateTimeIntl.js.map